import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ASSETS, LINKS } from "../data/content";

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.nav
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,box-shadow,backdrop-filter] duration-300 ${
        scrolled
          ? "bg-white/80 backdrop-blur-xl shadow-[0_8px_30px_rgb(0,0,0,0.06)] border-b border-black/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-[70px] flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-3"
        >
          <img
            src={ASSETS.logo}
            alt="Essay Advantage Club"
            className="h-11 w-11 rounded-full object-cover"
          />
          <span className="font-display font-extrabold text-[15px] md:text-lg tracking-tight leading-none hidden sm:block">
            ESSAY Advantage Club
          </span>
        </a>

        <div className="flex items-center gap-6">
          <a
            href="#timetable"
            data-testid="nav-schedule"
            className="hidden md:block text-sm font-bold text-[#4b5563] hover:text-[#111827] transition-colors"
          >
            Schedule
          </a>
          <a
            href="#proof"
            data-testid="nav-proof"
            className="hidden md:block text-sm font-bold text-[#4b5563] hover:text-[#111827] transition-colors"
          >
            Proof
          </a>
          <a
            href={LINKS.enrol}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-enrol-button"
            className="btn-3d bg-[#58cc02] text-white font-extrabold text-sm px-6 py-2.5 rounded-2xl uppercase tracking-wide"
          >
            Enrol · ₹1,100
          </a>
        </div>
      </div>
    </motion.nav>
  );
};

export default Nav;
